// "Continue with <provider>" buttons backed by Google Cloud Identity Platform.
// Ported from payreq-app/src/components/gcip-sign-in.tsx; here a successful popup hands
// the raw GCIP ID token up to App.tsx (which posts it to /sso/login) instead of doing an
// app-JWT exchange. The legacy GIS fallback is dropped — this page is GCIP-only.

import { useState } from "react";
import { toast } from "sonner";
import { Loader2, LogIn } from "lucide-react";

import { GCIP_PROVIDERS, SignInCancelled, signInWithProvider } from "@/lib/gcip";
import { Button } from "@/components/ui/button";

export function ProviderButtons({
  onIdToken,
  disabled,
}: {
  /** Receives the GCIP ID token; the returned promise keeps the button busy. */
  onIdToken: (idToken: string) => Promise<void>;
  disabled?: boolean;
}) {
  const [busyId, setBusyId] = useState<string | null>(null);

  const signIn = (id: string) => {
    setBusyId(id);
    signInWithProvider(id)
      .then(onIdToken)
      .catch((e) => {
        if (e instanceof SignInCancelled) return;
        toast.error(e instanceof Error ? e.message : "Sign-in failed.");
      })
      .finally(() => setBusyId(null));
  };

  return (
    <div className="flex flex-col gap-2">
      {GCIP_PROVIDERS.map((p) => (
        <Button
          key={p.id}
          type="button"
          variant="outline"
          className="h-12 w-full text-base"
          disabled={disabled || busyId !== null}
          onClick={() => signIn(p.id)}
        >
          {busyId === p.id ? <Loader2 className="animate-spin" /> : <LogIn className="size-4" />}
          Continue with {p.label}
        </Button>
      ))}
    </div>
  );
}
